/* -----------------Globals--------------- */
import { useState } from "react";

/* -----------------UI--------------- */
import { Loader } from "@memorang/ui";

import { useExamContext, useExams } from "@features/exam";

/* -----------------Types--------------- */
import type { ExamDetails } from "@features/exam";

/* -----------------Others--------------- */
import { useRouter } from "expo-router";
/* -----------------Child components--------------- */
import ProductsView from "../components/Store/ProductsView";

const StoreContainer = () => {
	const {
		handleSwitchExamContext,
		currentExamContext: { examId },
	} = useExamContext();

	const router = useRouter();
	const { groupedExams, isLoading } = useExams();

	const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

	const [searchQuery, setSearchQuery] = useState("");

	const currentCategoryExamSelected = groupedExams?.find((item) => {
		return item.data.find(({ exam }) => exam.id === examId);
	});
	const handleChangeSearch = (query: string) => setSearchQuery(query);

	const filteredProducts = groupedExams
		.map((section) => ({
			...section,
			data: section.data.filter((examDetails) =>
				examDetails.exam.name.toLowerCase().includes(searchQuery.toLowerCase()),
			),
		}))
		.filter(
			(section) =>
				(selectedFilters.length > 0
					? selectedFilters.includes(section.title)
					: true) &&
				(searchQuery
					? section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
						section.data.length > 0
					: true),
		);

	const finalGroupedExams = (
		searchQuery || selectedFilters.length ? filteredProducts : groupedExams
	).map((section) => ({
		...section,
		data: section.data.sort((a, b) =>
			a.exam.id === examId ? -1 : b.exam.id === examId ? 1 : 0,
		),
	}));

	if (isLoading) {
		return <Loader />;
	}

	const interceptHandleSwitchExamContext = (examDetails: ExamDetails) => {
		handleSwitchExamContext(examDetails);
		router.push("/home");
	};

	const filteredGroupedExams = [...finalGroupedExams]
		.sort(({ title }) => {
			return title === currentCategoryExamSelected?.title ? -1 : 1;
		})
		.filter((item) => {
			return item.data.length > 0;
		});

	const handleSelectFilter = (filter: string) => {
		if (selectedFilters.includes(filter)) {
			setSelectedFilters(selectedFilters.filter((f) => f !== filter));
		} else {
			setSelectedFilters([...selectedFilters, filter]);
		}
	};

	const filters = groupedExams.map((section) => section.title);

	return (
		<ProductsView
			products={filteredGroupedExams}
			searchQuery={searchQuery}
			selectedFilters={selectedFilters}
			handleSelectFilter={handleSelectFilter}
			filters={filters}
			handleChangeSearch={handleChangeSearch}
			handleSwitchExamContext={interceptHandleSwitchExamContext}
		/>
	);
};

export default StoreContainer;
